<template>

    <div v-if="current">
  
      <v-row>
        <v-col cols="12" sm="2">
          <v-alert dense text type="info">
            {{ counter_contratos }} contratos
          </v-alert>
        </v-col>
        <v-col cols="12" sm="2">
          <v-alert dense text type="warning">
            {{ counter_contratos_processados }} processados 
          </v-alert>
        </v-col>
        <v-col cols="12" sm="2">
          <v-alert dense text type="error">
            {{ counter_contratos_cobrar }} cobranças
          </v-alert>
        </v-col>
        <v-col cols="12" sm="2">
        <v-alert dense text type="success">
          {{ counter_contratos_cobrados }} cobrados
        </v-alert>
      </v-col>
        <v-col cols="12" sm="2">
          <v-btn color="warning" @click="processar()" block>Processar cobrança</v-btn>
        </v-col>
        <v-col cols="12" sm="2">
          <v-btn class="mr-2" color="primary" @click="atualizar()"><v-icon>mdi-refresh</v-icon></v-btn>
          <v-btn class="mr-2" color="primary" @click="csv()"><v-icon>mdi-file-delimited</v-icon></v-btn>
          <v-btn class="mr-2" color="primary" @click="whatsapp()"><v-icon>mdi-whatsapp</v-icon></v-btn>
        </v-col>
      </v-row>
      
      <v-simple-table>
        <thead>
          <tr>
            <th>Cliente</th>
            <th>Usuário</th>
            <th>Instalação</th>
            <th>Bloqueio</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in current" :key="item.id">
            <td>{{ item.clientName }}</td>
            <td>{{ item.username }}</td>
            <td>{{ item.setup | formatDate }}</td>
            <td>{{ item.blockDay | formatDate }}</td>
            <td><v-chip :color="colorStatus(item)" text-color="white" small>{{ item | formatStatus }}</v-chip></td>
          </tr>
        </tbody>
      </v-simple-table>
      
      <v-dialog v-model="dialog_loading" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Por favor aguarde
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>

    <v-dialog v-model="dialog_whatsapp" max-width="500px">
      <v-card>
        <v-card-title>Disparo de Cobrança para WhatsApp</v-card-title>
        <v-card-text>
          <v-text-field
              label="Número da última cobrança"
              v-model="finalNumber"
              outlined
              dense
              ></v-text-field>
          <v-select
              label="Template"
              v-model="template"
              :items="templateList"
              item-text="name"
              return-object
              outlined
              dense
              ></v-select>
          <div v-if="template" v-html="template.content" class="wss"></div>
          <v-text-field
              label="Limite de disparos"
              v-model="limit"
              outlined
              dense
              ></v-text-field>
          <v-alert
            type="warning"
            dense
            outlined
            class="mt-3"
          >
          Deseja enviar a mensagens de cobrança para {{ limit }} contatos de um total de {{ counter_contratos_whatsapp }}?
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="sendWhatsapp()">Disparar</v-btn>
          <v-btn color="default" @click="dialog_whatsapp = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  
    </div>
  
</template>
  
<script>
  import api from '../../api/index.js';
  export default {
    data: () => ({
      current: [],
      counter_contratos: 0,
      counter_contratos_processados: 0,
      counter_contratos_cobrar: 0,
      counter_contratos_cobrados: 0,
      counter_contratos_whatsapp: 0,
      dialog_loading: false,
      dialog_whatsapp: false,
      finalNumber: '',
      limit: 100,
      template: null,
      templateList: [
        { name: 'financeiro_cobranca_basica',
          content: `Prezado(a) {{nome}},
<br/><br/>
Identificamos em nosso sistema a existência de uma ou mais faturas em aberto em sua conta. Infelizmente, essa situação pode resultar no bloqueio do sinal dos serviços contratados.
<br/><br/>
O bloqueio está programado para ocorrer nos próximos dias. Para evitar quaisquer inconvenientes, solicitamos que entre em contato conosco através do botão abaixo o mais breve possível e regularize sua situação financeira.<br/><br/>`
        }
      ]
    }),
    created: function() {
      this.atualizar();
    },
    methods: {
      atualizar: function(){
        this.listCobrancas();
        this.countContratos();
        this.countContratosProcessados();
        this.countContratosCobrar();
        this.countContratosCobrados();
        this.countContratosWhatsapp();
      },
      countContratos: function(){
        var me = this;
        var token = localStorage.getItem("token");
        api.get("/internet/cobranca/contratos/count", {headers: { Authorization: "Bearer " + token }})
        .then(function(response) {
          me.counter_contratos = response.data;
        }) 
        .catch(function(error) {
          me.dialog_loading = false;
          console.log(error);
          alert("Falha ao recuperar contagem!");
        });
      },
      countContratosProcessados: function(){
        var me = this;
        var token = localStorage.getItem("token");
        api.get("/internet/cobranca/processados/count", {headers: { Authorization: "Bearer " + token }})
        .then(function(response) {
          me.counter_contratos_processados = response.data;
        }) 
        .catch(function(error) {
          me.dialog_loading = false;
          console.log(error);
          alert("Falha ao recuperar contagem!");
        });
      },
      countContratosCobrar: function(){
        var me = this;
        var token = localStorage.getItem("token");
        api.get("/internet/cobranca/cobrar/count", {headers: { Authorization: "Bearer " + token }})
        .then(function(response) {
          me.counter_contratos_cobrar = response.data;
        }) 
        .catch(function(error) {
          me.dialog_loading = false;
          console.log(error);
          alert("Falha ao recuperar contagem!");
        });
      },
      countContratosCobrados: function(){
        var me = this;
        var token = localStorage.getItem("token");
        api.get("/internet/cobranca/cobrados/count", {headers: { Authorization: "Bearer " + token }})
        .then(function(response) {
          me.counter_contratos_cobrados = response.data;
        }) 
        .catch(function(error) {
          me.dialog_loading = false;
          console.log(error);
          alert("Falha ao recuperar contagem de cobrados!");
        });
      },
      countContratosWhatsapp: function(){
        var me = this;
        var token = localStorage.getItem("token");
        api.get("/internet/cobranca/whatsapp/count", {headers: { Authorization: "Bearer " + token }})
        .then(function(response) {
          me.counter_contratos_whatsapp = response.data;
        }) 
        .catch(function(error) {
          me.dialog_loading = false;
          console.log(error);
          alert("Falha ao recuperar contagem de cobrados!");
        });
      },
      listCobrancas: function() {
        var me = this;
        me.current = [];
        var token = localStorage.getItem("token");
        me.dialog_loading = true;
        api.get("/internet/cobranca", {headers: { Authorization: "Bearer " + token }})
        .then(function(response) {
          me.dialog_loading = false;
          me.current = response.data;
        })
        .catch(function(error) {
          me.dialog_loading = false;
          console.log(error);
          alert("Falha ao recuperar listagem!");
        });
      },
      processar: function(){
        var me = this;
        var token = localStorage.getItem("token");
        me.dialog_loading = true;
        api.post("/internet/cobranca/rapida", null, {headers: { Authorization: "Bearer " + token }})
        .then(function(response) {
          me.dialog_loading = false;
          if(response.data=='started'){
              alert("Processamento iniciado com sucesso!");
          } else if(response.data=='running'){
              alert("Já existe um processamento em andamento!");
          } else {
              alert("Falha ao iniciar o processamento de cobrança!");
          }
          me.atualizar();
        })
        .catch(function(error) {
          me.dialog_loading = false;
          console.log(error);
          alert("Falha ao solicitar processamento de cobrança!");
        });
      },
      colorStatus: function(item){
        var color = "success";
        if (item.status==1){
          color = "warning";
        }else if(item.status==2){
          color = "secondary";
        }else if(item.status==3){
          color = "error";
        }else if(item.status==4){
          color = "default";
        }
        return color;
      },
      csv: function(){
        var content = "";
        for(var i=0;i<this.current.length;i++){
          let internet = this.current[i];
          content += ""+internet.clientCellphone+";"+internet.clientName+"\n";
        }
        var blob = new Blob([content], { type: "text/csv" });
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        let df = new Date().toISOString();
        a.download = "cobrancas-"+df+".csv";
        document.body.appendChild(a);
        a.click();
      },
      whatsapp: function(){
        var me = this;
        me.dialog_whatsapp = true;
      },
      sendWhatsapp: function(){
        var me = this;
        var token = localStorage.getItem("token");
        if(me.template==null) { 
          alert('Selecione o template.'); 
          return;
        }
        me.dialog_whatsapp = false;
        me.dialog_loading = true;
        api.post("/internet/cobranca/whatsapp/send", { finalNumber: me.finalNumber, template: me.template.name, limit: me.limit }, {headers: { Authorization: "Bearer " + token }})
        .then(function(response) {
          me.dialog_loading = false;
          console.log(response.data);
        }) 
        .catch(function(error) {
          me.dialog_loading = false;
          console.log(error);
          alert("Falha ao disparar mensagens!");
        });
      }
    },
    filters: {
      formatStatus: function(item){
        var text = "Habilitado";
        if (item.status==1){
          text = "Bloqueio administrador";
        }else if(item.status==2){
          text = "Bloqueio cliente";
        }else if(item.status==3){
          text = "Bloqueio pagamento";
        }else if(item.status==4){
          text = "Cancelado";
        }
        return text;
      }
    }
  }
  
</script>

<style lang="css">
.wss {
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 14px;
  background-color: rgb(196, 248, 212);
  margin-bottom: 32px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  color: black;
}
</style>